import * as React from 'react'
import joinClassNames from '../../../helpers/joinClassNames'

type Props = {
    label: string
    name: string
    isRequired: boolean
    wrapperClassName?: string
}

const Textarea = ({isRequired, name, wrapperClassName, label}: Props) => {
    const placeholder = isRequired ? `${label}*` : label

    return (
        <div className={joinClassNames('field', wrapperClassName)}>
            <div className="control">
                <textarea
                    name={name}
                    aria-label={name}
                    className="textarea"
                    required={isRequired}
                    placeholder={placeholder}
                />
            </div>
        </div>
    )
}

export default Textarea
